<app-attendee-card-collection
  [description]="description"
  [title]="title"
  [link]="link"
  [showCta]="seeMore"
>
  <ng-container *ngFor="let activity of activities">
    <a
      *appListItem
      [routerLink]="getPath(activity) | localize"
      [attr.aria-label]="activity.name"
    >
      <app-attendee-activity-card [activity]="activity" [isHp]="true">
      </app-attendee-activity-card>
    </a>
  </ng-container>
</app-attendee-card-collection>
